module.exports = __webpack_public_path__ + "static/008-cdff1adc0ecf6354c10f6ec782107bbf.png";